class Gift {
  constructor(data) {
    this.id = data.id
    this.canResendEmail = data.canResendEmail
    this.code = data.code
    this.message = data.message
    this.price = data.price
    this.product = data.product
    this.statusId = data.statusId
    this.subscription = data.subscription
    this.expiresOn = data.expiresOn
    this.periodAccess = data.periodAccess
    this.to = data.to
    this.toEmail = data.toEmail
  }
}
export default Gift;

